import { SB } from '@play-co/replicant';
import { tuple } from '../utils/types';

// How much real money user has spent in cents
export const lifetimeValue = SB.int();
export const rulesetLTV = SB.int();
export const actualLTV = SB.int();
export const checkoutSessionId = SB.string().optional(); // For Stripe
export const checkoutProductId = SB.string().optional(); // For Stripe
export const ageConsentJPAccepted = SB.boolean().default(false); // over 20 years

/**
 * Store Komoju, pending payments to check them later.
 * We migrated to from pendingPayment to pendingPayments to store multiple pending payments, and avoid overwriting issues.
 * You should always use pendingPayments instead of pendingPayment.
 */
export const pendingPayments = SB.array(
  SB.object({
    /**
     * The payment unique ID.
     * paymentProvider + _ + purchaseId
     */
    id: SB.string(),

    /**
     * In what currency the payment was made.
     */
    currency: SB.string(),

    /**
     * The amount of money
     */
    price: SB.number(),

    /**
     * We keep all old pending properties here
     */
    paymentProvider: SB.tuple(tuple('komoju')), // Formerly platformType

    /**
     * The payment method used by the user. komoju_paypay, komoju_credit_card, etc.
     * With provider prefix
     */
    paymentMethod: SB.string(),

    /**
     * Card brand, we need this to calculate fee. (optional)
     */
    creditCardBrand: SB.string().optional(),

    /**
     * Platform ID of the purchase, for different platforms could be different
     */
    purchaseId: SB.string(), // Formerly platformId

    /**
     * The product ID that the user bought.
     * @see ProductID type
     */
    productId: SB.string(),

    /**
     * When the payment was created.
     */
    createdAt: SB.number(),

    /**
     * Timestamp of the payment status change.
     */
    updatedAt: SB.number(),

    /**
     * Generic analytics
     */
    analytics: SB.object({
      feature: SB.string(),
      subFeature: SB.string(),
    }),

    /**
     * WebPay analytics event analytics
     */
    webPayAnalytics: SB.object({
      elapsedSecondsOpen: SB.number(),
      sessionOpenSequence: SB.number(),
      sessionSuccessSequence: SB.number(),
      instanceSelectSequence: SB.number(),
      sessionSuccessSequenceForMethod: SB.number(),
      instanceSelectSequenceForMethod: SB.number(),
      hasAgeCheckbox: SB.boolean(),
    }).optional(),

    /**
     * Timestamp of the payment method selection.
     * This is used to track the time it took for the user to select the payment method.
     */
    webPayMethodTimestamp: SB.number().optional(),

    /**
     * The status of pending payment.
     *
     * `pending`: Payment is not completed yet, and the user hasn't received their reward. We will check the status of this payment.
     * `captured`: Payment has been completed successfully, and the user has received their reward.
     * `canceled`: Payment was canceled by the user or the payment provider. The user did not receive the reward. We will no longer check the status of this payment.
     * `failed`: Payment failed for some reason. The user did not receive the reward. We will no longer check the status of this payment.
     */
    status: SB.tuple(tuple('pending', 'captured', 'canceled', 'failed')),
  }),
);

// Keep track of the last payment method used by the user.
export const lastPaymentMethod = SB.string().optional();
